import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import app from './modules/app.store'
import auth from './modules/auth.store'
import admin from './modules/admin.store'

import { STORE } from '@/constants'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: process.env.NODE_ENV === 'production' ? 'iandash' : 'iandash_dev',
  storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    [STORE.APP.NAME]: app,
    [STORE.ADMIN.NAME]: admin,
    auth
  },
  plugins: [
    vuexPersist.plugin
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js